@if((selectable && dataFetch !== null && dataSelect) || (!selectable && dataFetch !== null)){
<div class="grid gap-2 grid-cols-[repeat(auto-fit,minmax(0,1fr))]">
  @if(selectable){
    <!-- <mat-form-field class="example-full-width">
      <app-select [data]="dataSelect" [label]="'Seleccione ' + labelSelect"
        (selectValue)="selectValue($event)"></app-select>
    </mat-form-field> -->
    <app-autocomplete-field
      [label]="'Seleccione ' + labelSelect"
      [placeholder]="'Escribe para buscar...'"
      [options]="dataSelect"
      (optionSelected)="selectValue($event)">
    </app-autocomplete-field>
  }
  @if(filterable){
    <mat-form-field #filterfield>
      <mat-label>{{'Filtrar por ' + labelFilter}}</mat-label>
      <input matInput (keyup)="[onSearchInputChange($event.target.value),paginator.pageIndex = 0]" #input>
    </mat-form-field>
  }
  @if(showExtraButtonsTemplateRef){
    <div class="flex items-center">
      <ng-container *ngTemplateOutlet="templateRefExtraButtons"></ng-container>
    </div>
  }
</div>
<section class="table-container mat-elevation-z8" [style.height]="height" [style.width]="width" [ngClass]="clickable ? 'clickable' : ''" style="position: relative;">

  <ng-template #actionSwitch let-action let-element="element">
    @switch (action.value.type) {
      @case('link'){
        <app-button href="{{element['id']}}/{{action.value.url}}" typeButton="icon" text="{{action.value.icon}}" tooltip="{{action.value.traslation}}"></app-button>
      }
      @case('modal'){
        <button mat-icon-button matTooltip="{{action.value.traslation}}" (click)="openDialog(action.key,element['id'], action.value.showActionsButtons, action.value.modalSize ? action.value.modalSize : 'medium')">
          <mat-icon>{{action.value.icon}}</mat-icon>
        </button>
      }
      @default{
        <button mat-icon-button matTooltip="{{action.value.traslation}}" (click)="openDialog(
          action.key,element['id'] , action.value.showActionsButtons , action.value.modalSize ? action.value.modalSize : 'medium'
          )">
          <mat-icon>{{action.value.icon}}</mat-icon>
        </button>
      }
      @case('customFunction'){
        <app-button (click)="customFunction(element)" typeButton="icon" text="{{action.value.icon}}" tooltip="{{action.value.traslation}}"></app-button>
      }
    }
  </ng-template>
    <table mat-table [dataSource]="dataFetch?.data ?? []" matSort class="mat-elevation-z8">
        @for (column of columnsNames; track column) {
          @if(column.name !== 'actions'){
            <ng-container matColumnDef="{{ column.name }}">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by string">
                {{ column.label }}
              </th>
              <td mat-cell *matCellDef="let element">
                  @switch(column.pipe){
                    @case('date'){
                      {{element[column.name] | date : 'dd/MM/yyyy' }}
                    }
                    @case('oneToNo'){
                      {{element[column.name] | oneToNo }}
                    }
                    @case('nullToNo'){
                      {{element[column.name] | nullToNo }}
                    }
                    @case('siNoUniversal'){
                      {{ (column.name.includes('.') && element[column.name.split('.')[0]])
                          ? (element[column.name.split('.')[0]][column.name.split('.')[1]] | siNoUniversal)
                          : (element[column.name] | siNoUniversal) }}
                    }
                    @default{
                      {{ (column.name.includes('.') && element[column.name.split('.')[0]]) ? element[column.name.split('.')[0]][column.name.split('.')[1]] : element[column.name] }}
                    }
                  }
              </td>
            </ng-container>
          }
        }
      <ng-container matColumnDef="actions" stickyEnd>
        <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
        <td mat-cell *matCellDef="let element" style="cursor: pointer;">
          <div class="table-actions">
            @if(element.deleted_at == null){
              @for (action of actions | keyvalue ; track $index) {
                <ng-container *ngTemplateOutlet="actionSwitch; context: { $implicit: action, element: element }"></ng-container>
              }
            }@else if(actions){
              @for (action of actionsDeletedItems | keyvalue ; track $index) {
                <ng-container *ngTemplateOutlet="actionSwitch; context: { $implicit: action, element: element }"></ng-container>
              }

            }
          </div>
        </td>
      </ng-container>
      <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="columnKeys.length">
        <p>No se encontraron datos..</p>
      </td>
    </tr>
    <tr mat-header-row *matHeaderRowDef="columnKeys; sticky: true"></tr>
    @if(clickable){
      <tr
        mat-row
        (click)="selectRow(row)"
        *matRowDef="let row; columns: columnKeys;"
        [class.demo-row-is-clicked]="clickedRows.has(row)"
        [class.row-deleted]="row.deleted_at"
        [class.selected-row]="clickedRows.has(row)"
      ></tr>
    }@else{
      <tr mat-row *matRowDef="let row; columns: columnKeys" [class.row-deleted]="row.deleted_at"></tr>
    }
    </table>
    @if(isLoading){
      <div class="spinner-general">
        <mat-spinner></mat-spinner>
      </div>
    }
  @if(pagination){
    <mat-paginator
      [length]="totalItems"
      [pageSizeOptions]="[50 , 100]"
      aria-label="Select page of titulos"
      [showFirstLastButtons]="true"
      >
    </mat-paginator>
  }
</section>
}@else {
  @if(isLoadingAllData){
    <section class="table-container mat-elevation-z8" style="position: relative; min-height: 20vh;">
      <div class="spinner-general">
        <mat-spinner></mat-spinner>
      </div>
    </section>
  }
}
